import ArrowDownCircle from './arrow-down-circle.js';
import ArrowDownLeft from './arrow-down-left.js';
import ArrowDownToLine from './arrow-down-to-line.js';
import ArrowLeftArrowRightCircle from './arrow-left-arrow-right-circle.js';
import ArrowLeftArrowRightLarge from './arrow-left-arrow-right-large.js';
import ArrowLeftArrowRight from './arrow-left-arrow-right.js';
import ArrowRightCircle from './arrow-right-circle.js';
import ArrowRightRectangle from './arrow-right-rectangle.js';
import ArrowRight from './arrow-right.js';
import ArrowUpArrowDown from './arrow-up-arrow-down.js';
import ArrowUpFromSquareApple from './arrow-up-from-square-apple.js';
import ArrowUpRightFromSquare from './arrow-up-right-from-square.js';
import ArrowUpRight from './arrow-up-right.js';
import BadgeCheck from './badge-check.js';
import CaretDown from './caret-down.js';
import CaretLeft from './caret-left.js';
import CaretRight from './caret-right.js';
import CaretUpRightCaretDownLeftFromCenter from './caret-up-right-caret-down-left-from-center.js';
import CaretUpRightCaretDownLeftToCenter from './caret-up-right-caret-down-left-to-center.js';
import Check from './check.js';
import CircleArcLeft from './circle-arc-left.js';
import CircleArcRight from './circle-arc-right.js';
import CircleHalfStroke from './circle-half-stroke.js';
import CircleInfo from './circle-info.js';
import Circles from './circles.js';
import ClockArcRight from './clock-arc-right.js';
import Clock from './clock.js';
import ComputerMobile from './computer-mobile.js';
import CopyFilledCheck from './copy-filled-check.js';
import CopyFilled from './copy-filled.js';
import Copy from './copy.js';
import CurrencyCircle from './currency-circle.js';
import Currency from './currency.js';
import Earth from './earth.js';
import EyeSlashed from './eye-slashed.js';
import Eye from './eye.js';
import FilePen from './file-pen.js';
import Fingerprint from './fingerprint.js';
import GridSparkle from './grid-sparkle.js';
import HardDrive from './hard-drive.js';
import HexNutLarge from './hex-nut-large.js';
import HexNut from './hex-nut.js';
import LaptopCheck from './laptop-check.js';
import MagnifyingGlass from './magnifying-glass.js';
import Moon from './moon.js';
import PageKey from './page-key.js';
import Pause from './pause.js';
import PinFilled from './pin-filled.js';
import Pin from './pin.js';
import Play from './play.js';
import QrcodeScan from './qrcode-scan.js';
import RectangleHistory from './rectangle-history.js';
import Shapes from './shapes.js';
import ShieldCircle from './shield-circle.js';
import ShoppingBag from './shopping-bag.js';
import SmileyFace from './smiley-face.js';
import SquarePollVertical from './square-poll-vertical.js';
import Store from './store.js';
import Sun from './sun.js';
import TriangleDown from './triangle-down.js';
import Trophy from './trophy.js';
import Users from './users.js';
import Wallet from './wallet.js';
import WindowTerminal from './window-terminal.js';
import XMark from './x-mark.js';
import XTwitter from './x-twitter.js';
const variants = {
    'arrow-down-circle': ArrowDownCircle,
    'arrow-down-left': ArrowDownLeft,
    'arrow-down-to-line': ArrowDownToLine,
    'arrow-left-arrow-right-circle': ArrowLeftArrowRightCircle,
    'arrow-left-arrow-right-large': ArrowLeftArrowRightLarge,
    'arrow-left-arrow-right': ArrowLeftArrowRight,
    'arrow-right-circle': ArrowRightCircle,
    'arrow-right-rectangle': ArrowRightRectangle,
    'arrow-right': ArrowRight,
    'arrow-up-arrow-down': ArrowUpArrowDown,
    'arrow-up-from-square-apple': ArrowUpFromSquareApple,
    'arrow-up-right-from-square': ArrowUpRightFromSquare,
    'arrow-up-right': ArrowUpRight,
    'badge-check': BadgeCheck,
    'caret-down': CaretDown,
    'caret-left': CaretLeft,
    'caret-right': CaretRight,
    'caret-up-right-caret-down-left-from-center': CaretUpRightCaretDownLeftFromCenter,
    'caret-up-right-caret-down-left-to-center': CaretUpRightCaretDownLeftToCenter,
    check: Check,
    'circle-arc-left': CircleArcLeft,
    'circle-arc-right': CircleArcRight,
    'circle-half-stroke': CircleHalfStroke,
    'circle-info': CircleInfo,
    circles: Circles,
    'clock-arc-right': ClockArcRight,
    clock: Clock,
    'computer-mobile': ComputerMobile,
    'copy-filled-check': CopyFilledCheck,
    'copy-filled': CopyFilled,
    copy: Copy,
    'currency-circle': CurrencyCircle,
    currency: Currency,
    earth: Earth,
    'eye-slashed': EyeSlashed,
    eye: Eye,
    'file-pen': FilePen,
    fingerprint: Fingerprint,
    'grid-sparkle': GridSparkle,
    'hard-drive': HardDrive,
    'hex-nut-large': HexNutLarge,
    'hex-nut': HexNut,
    'laptop-check': LaptopCheck,
    'magnifying-glass': MagnifyingGlass,
    moon: Moon,
    'page-key': PageKey,
    pause: Pause,
    'pin-filled': PinFilled,
    pin: Pin,
    play: Play,
    'qrcode-scan': QrcodeScan,
    'rectangle-history': RectangleHistory,
    shapes: Shapes,
    'shield-circle': ShieldCircle,
    'shopping-bag': ShoppingBag,
    'smiley-face': SmileyFace,
    'square-poll-vertical': SquarePollVertical,
    store: Store,
    sun: Sun,
    'triangle-down': TriangleDown,
    trophy: Trophy,
    users: Users,
    wallet: Wallet,
    'window-terminal': WindowTerminal,
    'x-mark': XMark,
    'x-twitter': XTwitter,
};
export default variants;
